'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modal_module = require('./modal.module.scss.js');

var childModalCleanup = function (resolvedParent, timeoutId) {
    var _a;
    if (timeoutId) {
        clearTimeout(timeoutId);
    }
    (_a = resolvedParent === null || resolvedParent === void 0 ? void 0 : resolvedParent.classList) === null || _a === void 0 ? void 0 : _a.remove(modal_module.default['cat-modal--under-child']);
};
var focusElement = function (element, selector) {
    var _a;
    var eleToFocus = element === null || element === void 0 ? void 0 : element.querySelector(selector);
    (_a = eleToFocus === null || eleToFocus === void 0 ? void 0 : eleToFocus.focus) === null || _a === void 0 ? void 0 : _a.call(eleToFocus);
};
var getResolvedParent = function (current) {
    var _a;
    var closestParentThatIsAChildModal = (_a = current === null || current === void 0 ? void 0 : current.parentElement) === null || _a === void 0 ? void 0 : _a.closest(".".concat(modal_module.default['cat-modal--child']));
    var parentModal = current === null || current === void 0 ? void 0 : current.closest(".".concat(modal_module.default['cat-modal__content']));
    return closestParentThatIsAChildModal || parentModal;
};

exports.childModalCleanup = childModalCleanup;
exports.focusElement = focusElement;
exports.getResolvedParent = getResolvedParent;
//# sourceMappingURL=utils.js.map
